import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeEmployeeAnniversaryBirthdayReport extends Layout {
    checkboxPageBreakAfterGroupBy: Checkbox;
    excludabletextboxDivision: ExcludableTextbox;
    excludabletextboxTerminal: ExcludableTextbox;
    officeEmployeeAnniversaryBirthdayDatasource: DataSource;
    textboxDateRange: Textbox;
    textboxGroupBy: Textbox;
    textboxReportType: Textbox;
}
